module.exports = __webpack_public_path__ + "4a5d8910b58c5a17b7a6c5fc61b69ea2.pdf";